<template>
    <div class="gapp-error">
        <h2 class="gapp_post__module-title">{{ errorMsg }}.</h2> 
        <p>We encountered an error while fetching related posts.</p> 
    </div>
</template>

<script>
export default {
    props: {
        errorMsg: {
            type: String
        }
    }
}
</script>

